import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import InnerInventoryList from "../components/InnerInventoryList";
import DefaultTopBar from "../components/DefaultTopBar";

const InnerInventoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout> 

        <DefaultTopBar
            title="Manage Inventories"
        />

        {/* TableDataLayer */}
        <InnerInventoryList />

      </MasterLayout>

    </>
  );
};

export default InnerInventoryPage; 